import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-metric-mean",
  "use": "icon-metric-mean-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-metric-mean\"><path d=\"M8 4C5.8 4 4 5.8 4 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m0 7V5c1.7 0 3 1.3 3 3s-1.3 3-3 3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol